import { PricingRule, PricingRuleCreateRequest } from "./pricingRule";
import { PaymentType } from "./softwareLicence";

import { LicenceType } from ".";

export enum PricingSummaryKeys {
  PRICING_ID = "pricingId",
  DATE_OF_EFFECT = "dateOfEffect",
  UPDATE_DATE = "updateDate",
  EDITED_BY = "editedBy",
  CURRENCIES = "currencies",
}

export enum PricingKeys {
  PRICING_ID = "pricingId",
  DATE_OF_EFFECT = "dateOfEffect",
  UPDATE_DATE = "updateDate",
  EDITED_BY = "editedBy",
  PRICING_RULES = "pricingRules",
  CURRENCIES = "currencies",
}

export interface PricingSummary {
  [PricingKeys.PRICING_ID]: string;
  [PricingKeys.DATE_OF_EFFECT]: Date | string;
  [PricingKeys.UPDATE_DATE]: string | Date;
  [PricingKeys.EDITED_BY]: string;
  [PricingKeys.CURRENCIES]?: string;
}

export interface Pricing extends PricingSummary {
  [PricingKeys.PRICING_RULES]?: PricingRule[];
}

export interface PricingCreateRequest {
  [PricingKeys.DATE_OF_EFFECT]: Date | string;
  [PricingKeys.PRICING_RULES]?: PricingRuleCreateRequest[];
  softwareLicenceId: string;
}

export interface ApiPricingRules {
  billableOperationId: string;
  pricingRules: PricingRuleCreateRequest[];
}

export interface PricingFormModel {
  [PricingKeys.DATE_OF_EFFECT]?: string;
  [PricingKeys.PRICING_RULES]?: PricingRuleCreateRequest[];
  licenceType: LicenceType;
  paymentType: PaymentType;
  softwareLicenceId: string;
  apiPricingRules?: ApiPricingRules[];
  pricingId?: string;
}

export interface PricingUpdateRequest extends PricingCreateRequest {
  [PricingKeys.PRICING_ID]?: string;
}
